// extracted by mini-css-extract-plugin
module.exports = {"Component":"DataTableInternalAccount_Component__2PFmN"};